import React from "react";

import { Box, Chip, Menu, MenuItem } from "@mui/material";

import {
  DepartureBoardRounded,
  FavoriteRounded,
  InfoRounded,
  TouchAppRounded,
} from "@mui/icons-material";

import useModal from "../../../../../config/context/modalContext";
import { GreyPallet } from "../../../../../config/styles";
import useBus from "../../context";

import MainText from "../../../../../components/MainText";
import ModalViewBusSchedule from "../ModalViewBusSchedule";

export default function DepartOptions() {
  const { busSchedules } = useBus();
  const { pushAlert } = useModal();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [busDetail, setBusDetail] = React.useState<string | null>(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickBusDetail = (busId: string) => {
    setAnchorEl(null);
    setBusDetail(busId);
  };

  const handleInfoClick = () => {
    pushAlert({
      type: "default",
      title: "Informações",
      isClosable: true,
      children: (
        <>
          <>
            <Box display={"flex"} alignItems={"center"} mb={1}>
              <FavoriteRounded fontSize={"small"} sx={{ mr: 0.5 }} />
              <MainText size="caption">Parada Favorita</MainText>
            </Box>
            <MainText size="caption" color="regular">
              - Os horários na parada favorita indicam a hora estimada que aquele ônibus vai chegar
              na nela.
            </MainText>
            <MainText size="caption" color="regular">
              - Ao clicar no balãozinho do horário, serão exibidas todas as estimativas do ônibus
              clicado para aquela parada, indicando com uma transparências aqueles que já passaram.
            </MainText>
          </>

          <Box mt={3} />

          <>
            <Box display={"flex"} alignItems={"center"} mb={1}>
              <DepartureBoardRounded fontSize={"small"} sx={{ mr: 0.5 }} />
              <MainText size="caption">
                Todos os horários das tabelas são horários de saída dos ônibus.
              </MainText>
            </Box>
            <MainText size="caption" color="regular">
              - Os Expressos saem do terminal no Via Direta.
            </MainText>
            <MainText size="caption" color="regular">
              - O Direto e Inverso saem do terminal do Restaurante Universitário (RU).
            </MainText>
            <MainText size="caption" color="regular">
              - Nos Expressos, os ícones de "Talheres" significam que o ônibus irá para o terminal
              do RU. (Os motoristas tem uma pausa que é feita no ponto de apoio lá no terminal)
            </MainText>
            <MainText size="caption" color="regular">
              - Nos Expressos, os ícones de "Ônibus" significam que o ônibus sairá do terminal do RU
              ao invés do Via Direta.
            </MainText>
          </>

          <Box mt={3} />

          <>
            <Box display={"flex"} alignItems={"center"} mb={1}>
              <TouchAppRounded fontSize={"small"} sx={{ mr: 0.5 }} />
              <MainText size="caption">
                Ao clicar e segurar no horário de saída, serão exibidas informações adicionais.
              </MainText>
            </Box>
            <MainText size="caption" color="regular">
              - No Direto e Inverso, será exibido a empresa do ônibus em questão.
            </MainText>
            <MainText size="caption" color="regular">
              - Nos Expressos apenas será exibida a descrição do ícone que eles tem.
            </MainText>
          </>
        </>
      ),
    });
  };

  return (
    <Box display={"flex"} justifyContent={"start"} gap={1} flexWrap={"wrap"}>
      {busDetail ? (
        <ModalViewBusSchedule busId={busDetail} onClose={() => setBusDetail(null)} />
      ) : null}

      <Chip
        label={
          <Box display={"flex"} alignItems={"center"} style={{ color: GreyPallet.Regular }}>
            <InfoRounded fontSize={"small"} sx={{ mr: 1 }} />
            <MainText size="small" color="regular">
              Informações
            </MainText>
          </Box>
        }
        variant={"filled"}
        style={{ borderWidth: 3 }}
        onClick={handleInfoClick}
      />

      <Chip
        label={
          <Box display={"flex"} alignItems={"center"} style={{ color: GreyPallet.Regular }}>
            <DepartureBoardRounded fontSize={"small"} sx={{ mr: 1 }} />
            <MainText size="small" color="regular">
              Outros Horários
            </MainText>
          </Box>
        }
        variant={"filled"}
        style={{ borderWidth: 3 }}
        onClick={handleClick}
      />

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {Object.keys(busSchedules).map((scheduleId: string) => (
          <MenuItem key={scheduleId} onClick={() => handleClickBusDetail(scheduleId)}>
            {busSchedules?.[scheduleId].name}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
